/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Track_Filters_LabelInputs */



/**
* | output |
* | --- |
* | "Track filters" |
*
* @param {Editor_Track_Filters_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_track_filters_label = /** @type {((inputs?: Editor_Track_Filters_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Track_Filters_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtres de suivi")
	if (locale === "de") return /** @type {LocalizedString} */ ("Trackfilter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtri tracciati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильтры отслеживания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtros de seguimiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("跟踪过滤器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックフィルター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक फ़िल्टर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtros de rastreamento")
	return /** @type {LocalizedString} */ ("Track filters")
});